var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.514429 11.5387L19.5 0.57735L38.4856 11.5387V33.4613L19.5 44.4226L0.514429 33.4613V11.5387Z",
    fill: "#4265AB",
    stroke: "#1F3560"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountyIcon);
export default __webpack_public_path__ + "static/media/countyIcon.075a25f59fafbf65ccd0af06d8898855.svg";
export { ForwardRef as ReactComponent };